$expandArrowWidth: 42px;
$checkboxWidth: 32px;

$aside: 300px;
$asideMinimized: 75px;
// Includes 300px of aside + Arrow width
$tableSidesSpace: 180px;

table .has-multiselect .expandable-container {
  margin-left: calc($expandArrowWidth + $checkboxWidth);
}

table .expandable-container {
  margin-left: $expandArrowWidth;

  width: calc(100vw - $tableSidesSpace - $aside);
  position: sticky;
  left: 16px;

  &.has-multiselect {
    margin-left: calc($expandArrowWidth + $checkboxWidth);
    width: calc(100vw - $tableSidesSpace - $aside - $checkboxWidth);
  }

  [data-kt-aside-minimize='on'] & {
    width: calc(100vw - $tableSidesSpace - $asideMinimized);

    &.has-multiselect {
      width: calc(100vw - $tableSidesSpace - $asideMinimized - $checkboxWidth);
    }
  }

  // As table
  &.as-table {
    display: table;
    box-sizing: border-box;
    text-indent: initial;
    unicode-bidi: isolate;
    caption-side: bottom;
    border-collapse: collapse;

    // tr
    div.field-row {
      display: table-row;
      vertical-align: middle;
      unicode-bidi: isolate;
      border-color: inherit;

      > div {
        // td
        display: table-cell;
        vertical-align: inherit;
        unicode-bidi: isolate;

        width: auto;

        // th
        &.field-label {
          font-weight: bold;
          text-align: -internal-center;

          padding-right: 60px;
          min-width: 175px;
          white-space: nowrap;
        }
      }

      &:not(:last-child) {
        &.mb-1 > div {
          padding-bottom: 0.25rem;
        }
        &.mb-2 > div {
          padding-bottom: 0.5rem;
        }
      }
    }
  }

  // Another table inside expanded view
  .card-table {
    background-color: transparent;
    overflow: hidden;

    .card-body {
      padding-bottom: 0.5rem;

      .table {
        margin-bottom: 0;

        thead > tr {
          background-color: var(--bs-gray-100);

          > th.header-actions {
            background-color: var(--bs-gray-100);
          }
        }
        tbody > tr {
          background-color: var(--bs-gray-50);

          > td.row-actions {
            background-color: var(--bs-gray-50);
          }
        }
      }
    }
  }
}

// Mobile screens (no aside)
@media (max-width: 992px) {
  table .expandable-container {
    width: calc(
      100vw - $tableSidesSpace + 30px
    ) !important; // 30px from container, space released

    &.has-multiselect {
      width: calc(100vw - $tableSidesSpace - $checkboxWidth + 30px) !important;
    }
  }
}
